import {observable, action} from 'mobx';

class Day {
  @observable events = [];
  @observable time = null;
  @observable open = false;
  person = null;

  constructor(time) {
    this.time = time;
  }

  @action addEvent (event) {
    this.events.push(event);
  }

  @action removeEventAt(index) {
    this.events.splice(index, 1);
  };

  @action toggleOpen() {
    this.open = !this.open;
  }
}

export default Day;


// WEBPACK FOOTER //
// ./src/views/Beeper/Day.js